var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="full-rules-modal"> <div data-bind="html: personalDataProcessingInfo"></div> </div>';
}
return __p;
};
